import { render } from "./ApprovalProcessDialog.vue?vue&type=template&id=1e9b8351&scoped=true"
import script from "./ApprovalProcessDialog.vue?vue&type=script&lang=ts"
export * from "./ApprovalProcessDialog.vue?vue&type=script&lang=ts"

import "./ApprovalProcessDialog.vue?vue&type=style&index=0&id=1e9b8351&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1e9b8351"

export default script